// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ReferenceToImageNode 样式 */

/* 节点容器 */
.ReferenceToImageNode-container {
  position: relative;
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  min-width: 320px;
}

.ReferenceToImageNode-container:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  border-color: #10b981;
}

/* 标题 */
.ReferenceToImageNode-title {
  padding: 12px 16px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  font-weight: 600;
  font-size: 14px;
  border-radius: 10px 10px 0 0;
  text-align: center;
  user-select: none;
}

/* Handle 样式 */
.ReferenceToImageNode-handle {
  width: 14px;
  height: 14px;
  border: 2px solid #10b981;
  background: white;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.ReferenceToImageNode-handle:hover {
  width: 18px;
  height: 18px;
  border-width: 3px;
}

.ReferenceToImageNode-handle-prompt {
  border-color: #667eea;
  background: #667eea;
}

.ReferenceToImageNode-handle-image {
  border-color: #48bb78;
  background: #48bb78;
}

.ReferenceToImageNode-handle-output {
  border-color: #10b981;
  background: #10b981;
}

/* Handle 标签 */
.ReferenceToImageNode-handle-label {
  position: absolute;
  left: -70px;
  top: 50%;
  transform: translateY(-50%);
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(8px);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  letter-spacing: 0.025em;
  z-index: 100;
}

.ReferenceToImageNode-handle:hover .ReferenceToImageNode-handle-label {
  opacity: 1;
  transform: translateY(-50%) translateX(-2px);
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.35);
}

.ReferenceToImageNode-handle:hover .ReferenceToImageNode-handle-label::before {
  content: '';
  position: absolute;
  right: -4px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 4px solid #10b981;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  filter: drop-shadow(0 1px 2px rgba(16, 185, 129, 0.2));
}

.ReferenceToImageNode-handle-prompt .ReferenceToImageNode-handle-label {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);
}

.ReferenceToImageNode-handle-prompt:hover .ReferenceToImageNode-handle-label {
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);
}

.ReferenceToImageNode-handle-prompt:hover .ReferenceToImageNode-handle-label::before {
  border-left-color: #667eea;
  filter: drop-shadow(0 1px 2px rgba(102, 126, 234, 0.2));
}

.ReferenceToImageNode-handle-image .ReferenceToImageNode-handle-label {
  background: linear-gradient(135deg, #48bb78 0%, #2d7a5f 100%);
  box-shadow: 0 4px 12px rgba(72, 187, 120, 0.25);
}

.ReferenceToImageNode-handle-image:hover .ReferenceToImageNode-handle-label {
  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);
}

.ReferenceToImageNode-handle-image:hover .ReferenceToImageNode-handle-label::before {
  border-left-color: #48bb78;
  filter: drop-shadow(0 1px 2px rgba(72, 187, 120, 0.2));
}

/* 节点被选中时，一直显示标签 */
.react-flow__node.selected .ReferenceToImageNode-handle .ReferenceToImageNode-handle-label {
  opacity: 1;
  transform: translateY(-50%) translateX(-2px);
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.35);
}

.react-flow__node.selected .ReferenceToImageNode-handle-prompt .ReferenceToImageNode-handle-label {
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);
}

.react-flow__node.selected .ReferenceToImageNode-handle-image .ReferenceToImageNode-handle-label {
  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);
}

/* 标签出现动画 */
@keyframes ReferenceToImageNode-labelFadeIn {
  0% {
    opacity: 0;
    transform: translateY(-50%) translateX(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(-50%) translateX(-2px);
  }
}

.ReferenceToImageNode-handle:hover .ReferenceToImageNode-handle-label,
.react-flow__node.selected .ReferenceToImageNode-handle .ReferenceToImageNode-handle-label {
  animation: ReferenceToImageNode-labelFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 内容包装器 */
.ReferenceToImageNode-wrapper {
  padding: 16px;
  width: 320px;
}

.ReferenceToImageNode-field {
  margin-bottom: 12px;
}

.ReferenceToImageNode-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #333;
  margin-bottom: 6px;
}

.ReferenceToImageNode-button-group {
  display: flex;
  gap: 8px;
}

.ReferenceToImageNode-button {
  flex: 1;
  padding: 8px;
  background: white;
  color: #333;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.ReferenceToImageNode-button-active {
  background: #10b981;
  color: white;
}

.ReferenceToImageNode-select {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 13px;
  background: white;
}

.ReferenceToImageNode-hint {
  margin-bottom: 12px;
  padding: 10px;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 6px;
  font-size: 12px;
  color: #166534;
  line-height: 1.5;
}

.ReferenceToImageNode-status {
  margin-top: 12px;
  padding: 8px;
  background: #e0f2fe;
  border: 1px solid #bae6fd;
  border-radius: 6px;
  font-size: 12px;
  color: #0c4a6e;
  text-align: center;
  font-weight: 500;
}

.ReferenceToImageNode-results {
  margin-top: 12px;
  padding: 12px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

.ReferenceToImageNode-results-title {
  font-size: 13px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
}

.ReferenceToImageNode-images {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ReferenceToImageNode-image-item {
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  background: white;
}

.ReferenceToImageNode-image {
  width: 100%;
  display: block;
}

.ReferenceToImageNode-image-info {
  padding: 6px 8px;
  background: rgba(0, 0, 0, 0.05);
  font-size: 11px;
  color: #666;
  text-align: center;
}

.ReferenceToImageNode-generate {
  width: 100%;
  padding: 12px;
  background: #10b981;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.ReferenceToImageNode-generate:hover {
  background: #059669;
}

.ReferenceToImageNode-generate-disabled {
  background: #ccc;
  cursor: not-allowed;
}

.ReferenceToImageNode-error {
  margin-top: 12px;
  padding: 8px;
  background: #fee;
  border: 1px solid #fcc;
  border-radius: 6px;
  font-size: 12px;
  color: #c33;
}

/* 参考图片网格展示 */
.ReferenceToImageNode-image-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  margin-top: 8px;
}

.ReferenceToImageNode-image-thumb {
  position: relative;
  aspect-ratio: 1;
  border-radius: 6px;
  overflow: hidden;
  border: 2px solid #e5e7eb;
  cursor: move;
  transition: all 0.2s;
  background: #f9fafb;
}

.ReferenceToImageNode-image-thumb:hover {
  border-color: #10b981;
  transform: scale(1.05);
  z-index: 10;
}

.ReferenceToImageNode-image-dragging {
  opacity: 0.5;
  transform: scale(0.95);
}

.ReferenceToImageNode-thumb-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.ReferenceToImageNode-thumb-index {
  position: absolute;
  top: 4px;
  right: 4px;
  background: rgba(16, 185, 129, 0.9);
  color: white;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 600;
}

/* 复制按钮样式 */
.ReferenceToImageNode-duplicate-button {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: white;
  color: #666;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.2s ease;
  opacity: 0;
  pointer-events: none;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.ReferenceToImageNode-container:hover .ReferenceToImageNode-duplicate-button {
  opacity: 1;
  pointer-events: auto;
}

.ReferenceToImageNode-duplicate-button:hover {
  background: #f0f0f0;
  border-color: #3b82f6;
  color: #3b82f6;
  transform: scale(1.05);
}

.ReferenceToImageNode-duplicate-button:active {
  transform: scale(0.95);
}

.react-flow__node.selected .ReferenceToImageNode-duplicate-button {
  opacity: 1;
  pointer-events: auto;
}

`, "",{"version":3,"sources":["webpack://./src/components/canvas/nodes/ReferenceToImageNode.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B,SAAS;AACT;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA,OAAO;AACP;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,iDAAiD;EACjD,+CAA+C;EAC/C,0CAA0C;EAC1C,0BAA0B;EAC1B,yCAAyC;EACzC,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,iCAAiC;EACjC,oCAAoC;EACpC,sDAAsD;AACxD;;AAEA;EACE,6DAA6D;EAC7D,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,0BAA0B;EAC1B,uDAAuD;AACzD;;AAEA;EACE,6DAA6D;EAC7D,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,0BAA0B;EAC1B,sDAAsD;AACxD;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,+CAA+C;AACjD;;AAEA,WAAW;AACX;EACE;IACE,UAAU;IACV,6CAA6C;EAC/C;EACA;IACE,UAAU;IACV,4CAA4C;EAC9C;AACF;;AAEA;;EAEE,6EAA6E;AAC/E;;AAEA,UAAU;AACV;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA,aAAa;AACb;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,mCAAmC;EACnC,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB","sourcesContent":["/* ReferenceToImageNode 样式 */\n\n/* 节点容器 */\n.ReferenceToImageNode-container {\n  position: relative;\n  background: white;\n  border: 2px solid #e5e7eb;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transition: all 0.2s ease;\n  min-width: 320px;\n}\n\n.ReferenceToImageNode-container:hover {\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n  border-color: #10b981;\n}\n\n/* 标题 */\n.ReferenceToImageNode-title {\n  padding: 12px 16px;\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n  font-weight: 600;\n  font-size: 14px;\n  border-radius: 10px 10px 0 0;\n  text-align: center;\n  user-select: none;\n}\n\n/* Handle 样式 */\n.ReferenceToImageNode-handle {\n  width: 14px;\n  height: 14px;\n  border: 2px solid #10b981;\n  background: white;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n}\n\n.ReferenceToImageNode-handle:hover {\n  width: 18px;\n  height: 18px;\n  border-width: 3px;\n}\n\n.ReferenceToImageNode-handle-prompt {\n  border-color: #667eea;\n  background: #667eea;\n}\n\n.ReferenceToImageNode-handle-image {\n  border-color: #48bb78;\n  background: #48bb78;\n}\n\n.ReferenceToImageNode-handle-output {\n  border-color: #10b981;\n  background: #10b981;\n}\n\n/* Handle 标签 */\n.ReferenceToImageNode-handle-label {\n  position: absolute;\n  left: -70px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n  padding: 6px 12px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n  pointer-events: none;\n  opacity: 0;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(8px);\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n  letter-spacing: 0.025em;\n  z-index: 100;\n}\n\n.ReferenceToImageNode-handle:hover .ReferenceToImageNode-handle-label {\n  opacity: 1;\n  transform: translateY(-50%) translateX(-2px);\n  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.35);\n}\n\n.ReferenceToImageNode-handle:hover .ReferenceToImageNode-handle-label::before {\n  content: '';\n  position: absolute;\n  right: -4px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 0;\n  height: 0;\n  border-left: 4px solid #10b981;\n  border-top: 4px solid transparent;\n  border-bottom: 4px solid transparent;\n  filter: drop-shadow(0 1px 2px rgba(16, 185, 129, 0.2));\n}\n\n.ReferenceToImageNode-handle-prompt .ReferenceToImageNode-handle-label {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);\n}\n\n.ReferenceToImageNode-handle-prompt:hover .ReferenceToImageNode-handle-label {\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);\n}\n\n.ReferenceToImageNode-handle-prompt:hover .ReferenceToImageNode-handle-label::before {\n  border-left-color: #667eea;\n  filter: drop-shadow(0 1px 2px rgba(102, 126, 234, 0.2));\n}\n\n.ReferenceToImageNode-handle-image .ReferenceToImageNode-handle-label {\n  background: linear-gradient(135deg, #48bb78 0%, #2d7a5f 100%);\n  box-shadow: 0 4px 12px rgba(72, 187, 120, 0.25);\n}\n\n.ReferenceToImageNode-handle-image:hover .ReferenceToImageNode-handle-label {\n  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);\n}\n\n.ReferenceToImageNode-handle-image:hover .ReferenceToImageNode-handle-label::before {\n  border-left-color: #48bb78;\n  filter: drop-shadow(0 1px 2px rgba(72, 187, 120, 0.2));\n}\n\n/* 节点被选中时，一直显示标签 */\n.react-flow__node.selected .ReferenceToImageNode-handle .ReferenceToImageNode-handle-label {\n  opacity: 1;\n  transform: translateY(-50%) translateX(-2px);\n  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.35);\n}\n\n.react-flow__node.selected .ReferenceToImageNode-handle-prompt .ReferenceToImageNode-handle-label {\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);\n}\n\n.react-flow__node.selected .ReferenceToImageNode-handle-image .ReferenceToImageNode-handle-label {\n  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);\n}\n\n/* 标签出现动画 */\n@keyframes ReferenceToImageNode-labelFadeIn {\n  0% {\n    opacity: 0;\n    transform: translateY(-50%) translateX(-10px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(-50%) translateX(-2px);\n  }\n}\n\n.ReferenceToImageNode-handle:hover .ReferenceToImageNode-handle-label,\n.react-flow__node.selected .ReferenceToImageNode-handle .ReferenceToImageNode-handle-label {\n  animation: ReferenceToImageNode-labelFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* 内容包装器 */\n.ReferenceToImageNode-wrapper {\n  padding: 16px;\n  width: 320px;\n}\n\n.ReferenceToImageNode-field {\n  margin-bottom: 12px;\n}\n\n.ReferenceToImageNode-label {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 6px;\n}\n\n.ReferenceToImageNode-button-group {\n  display: flex;\n  gap: 8px;\n}\n\n.ReferenceToImageNode-button {\n  flex: 1;\n  padding: 8px;\n  background: white;\n  color: #333;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.ReferenceToImageNode-button-active {\n  background: #10b981;\n  color: white;\n}\n\n.ReferenceToImageNode-select {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 13px;\n  background: white;\n}\n\n.ReferenceToImageNode-hint {\n  margin-bottom: 12px;\n  padding: 10px;\n  background: #f0fdf4;\n  border: 1px solid #bbf7d0;\n  border-radius: 6px;\n  font-size: 12px;\n  color: #166534;\n  line-height: 1.5;\n}\n\n.ReferenceToImageNode-status {\n  margin-top: 12px;\n  padding: 8px;\n  background: #e0f2fe;\n  border: 1px solid #bae6fd;\n  border-radius: 6px;\n  font-size: 12px;\n  color: #0c4a6e;\n  text-align: center;\n  font-weight: 500;\n}\n\n.ReferenceToImageNode-results {\n  margin-top: 12px;\n  padding: 12px;\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n}\n\n.ReferenceToImageNode-results-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 12px;\n}\n\n.ReferenceToImageNode-images {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.ReferenceToImageNode-image-item {\n  position: relative;\n  border-radius: 6px;\n  overflow: hidden;\n  border: 1px solid #e5e7eb;\n  background: white;\n}\n\n.ReferenceToImageNode-image {\n  width: 100%;\n  display: block;\n}\n\n.ReferenceToImageNode-image-info {\n  padding: 6px 8px;\n  background: rgba(0, 0, 0, 0.05);\n  font-size: 11px;\n  color: #666;\n  text-align: center;\n}\n\n.ReferenceToImageNode-generate {\n  width: 100%;\n  padding: 12px;\n  background: #10b981;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.ReferenceToImageNode-generate:hover {\n  background: #059669;\n}\n\n.ReferenceToImageNode-generate-disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n.ReferenceToImageNode-error {\n  margin-top: 12px;\n  padding: 8px;\n  background: #fee;\n  border: 1px solid #fcc;\n  border-radius: 6px;\n  font-size: 12px;\n  color: #c33;\n}\n\n/* 参考图片网格展示 */\n.ReferenceToImageNode-image-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.ReferenceToImageNode-image-thumb {\n  position: relative;\n  aspect-ratio: 1;\n  border-radius: 6px;\n  overflow: hidden;\n  border: 2px solid #e5e7eb;\n  cursor: move;\n  transition: all 0.2s;\n  background: #f9fafb;\n}\n\n.ReferenceToImageNode-image-thumb:hover {\n  border-color: #10b981;\n  transform: scale(1.05);\n  z-index: 10;\n}\n\n.ReferenceToImageNode-image-dragging {\n  opacity: 0.5;\n  transform: scale(0.95);\n}\n\n.ReferenceToImageNode-thumb-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.ReferenceToImageNode-thumb-index {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  background: rgba(16, 185, 129, 0.9);\n  color: white;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n/* 复制按钮样式 */\n.ReferenceToImageNode-duplicate-button {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 28px;\n  height: 28px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  background: white;\n  color: #666;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  opacity: 0;\n  pointer-events: none;\n  z-index: 10;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.ReferenceToImageNode-container:hover .ReferenceToImageNode-duplicate-button {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.ReferenceToImageNode-duplicate-button:hover {\n  background: #f0f0f0;\n  border-color: #3b82f6;\n  color: #3b82f6;\n  transform: scale(1.05);\n}\n\n.ReferenceToImageNode-duplicate-button:active {\n  transform: scale(0.95);\n}\n\n.react-flow__node.selected .ReferenceToImageNode-duplicate-button {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
